import { defineRelease } from '../types'

const SETTINGS_ADMINS = ['iam_org_admin', 'iam_superadmin', 'ticketing_admin']

export default defineRelease({
  version: '2026.10.4',
  date: '2026-10-09',
  summary: 'Ticket General settings now apply to every channel.',
  entries: [
    {
      id: 'general-settings-all-channels',
      type: 'improved',
      module: 'helpdesk',
      title: 'General settings now apply to email and WhatsApp tickets',
      body: 'Default priority and category, Allow attachments and the attachment size limit now apply to tickets and replies that arrive by email or WhatsApp too. Files that aren’t allowed are noted on the ticket instead of being saved.',
      link: { to: '/tickets/settings?section=general', label: 'Open General settings' },
      roles: SETTINGS_ADMINS,
      service: 'ticket-mgmt',
    },
    {
      id: 'email-reopen-rules',
      type: 'improved',
      module: 'helpdesk',
      title: 'Email replies follow your reopen rules',
      body: 'A reply to a closed ticket only reopens it when Allow reopen is on and the reopen window hasn’t passed. Otherwise it goes to the ticket that already continues the conversation, and only opens a new follow-up when there isn’t one — so repeated replies never pile up as duplicate tickets.',
      link: { to: '/tickets/settings?section=general', label: 'Open General settings' },
      roles: SETTINGS_ADMINS,
      service: 'ticket-mgmt',
    },
    {
      id: 'follow-up-notice',
      type: 'new',
      module: 'helpdesk',
      title: 'Customers are told when their reply opens a new ticket',
      body: 'They get an email with the new ticket number, so their next reply goes straight to it. Turn it off or change the wording in General settings and the “Follow-up Ticket - Requester” email template.',
      link: { to: '/tickets/settings?section=general', label: 'Open General settings' },
      roles: SETTINGS_ADMINS,
      service: 'ticket-mgmt',
    },
    {
      id: 'follow-up-links',
      type: 'new',
      module: 'helpdesk',
      title: 'Follow-up tickets link to the ticket they continue',
      body: 'A follow-up shows “Follow-up to #N” at the top, and the closed ticket lists its follow-ups, so the whole conversation is one click away.',
      roles: ['iam_org_admin', 'iam_superadmin', 'ticketing_admin', 'lead_agent', 'ticketing_agent'],
      service: 'ticket-mgmt',
    },
    {
      id: 'auto-close-scheduled',
      type: 'fixed',
      module: 'helpdesk',
      title: 'Resolved tickets now auto-close on schedule',
      body: 'Auto-close only ran when General settings were saved, so tickets resolved later never closed. It now checks every hour.',
      roles: SETTINGS_ADMINS,
      service: 'ticket-mgmt',
    },
    {
      id: 'portal-off-blocks-access',
      type: 'fixed',
      module: 'helpdesk',
      title: 'Turning off the customer portal blocks all portal access',
      body: 'Portal users who were already signed in could still view tickets and comments after the portal was turned off. Now they can’t view, comment on or create tickets until it’s turned back on.',
      roles: SETTINGS_ADMINS,
      service: 'ticket-mgmt',
    },
  ],
})
